import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "widgetMenu",
  "use": "widgetMenu-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"widgetMenu\"><g stroke=\"#000\" stroke-width=\"1.5\"><path d=\"m0 1h10\" /><path d=\"m0 5h10\" /><path d=\"m0 9h10\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol